export default "__VITE_ASSET__CY5OtNUK__"